const contrato = [
    {
        key: "contrato",
        label: "Nro. Contrato",
        sortable: true,
    },
    {
        key: "cantidaVehciulos",
        label: "Cantidad Vehículos",
        sortable: true,
    },
    {
        key: "fechaInicio",
        label: "Fecha de inicio",
        sortable: true,
    },
    {
        key: "fechaTermino",
        label: "Fecha de devolución",
        sortable: true,
    },
    {
        key: "duracion",
        label: "Plazo",
        sortable: true,
    }

];

const cotizacion = [
    {
        key: "numero",
        label: "Nro. Cotización",
        sortable: true,
    },
    {
        key: "tipologia",
        label: "Topología del Vehículo",
        sortable: true,
    },
    {
        key: "fecha",
        label: "Fecha de Cotización",
        sortable: true,
    },
    {
        key: "tarifa",
        label: "Tarifa",
        sortable: true,
    },
    {
        key: "plazo",
        label: "Plazo",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    }

];

const boleta_factura = [
    {
        key: "numeroDocumento",
        label: "Número",
        sortable: true,
    },
    {
        key: "contrato",
        label: "Nro. Contrato",
        sortable: true,
    },
    {
        key: "descripcionDocumento",
        label: "Tipo",
        sortable: true,
    },
    {
        key: "rut",
        label: "RUT Empresa",
        sortable: true,
    },
    {
        key: "rutFacturacion",
        label: "RUT Facturación",
        sortable: true,
    },
    {
        key: "fechaEmision",
        label: "Fecha emisión",
        sortable: true,
    },
    {
        key: "totalDocumento",
        label: "Monto",
        sortable: true,
    },
    {
        key: "saldoDocumento",
        label: "Saldo",
        sortable: true,
    },
    {
        key: "descarga",
        label: "Descargar",
        sortable: true,
    },
    {
        key: "pagar",
        label: "Pagar",
    }

];


module.exports = {
    contrato,
    cotizacion,
    boleta_factura,
};